export default (postcode: string) => {
  const re = /(\S*)\s*(\d)/g
  return postcode.replace(re, '$1 $2').toUpperCase()
}
